<h1>Taxonomies</h1>
<span class="messages">
    <span *ngIf="taxEditor != ''">
        {{ taxEditor }} is currently editing taxonomies <button type="button" class="button small" (click)="takeover()">Take Over</button>
    </span>
    <img src="/wp-content/themes/swarm/app/assets/images/loading.gif" *ngIf="loading" class="loader">
    <span *ngIf="saved" class="save-text"> <mat-icon>check</mat-icon> Saved! </span>
    <span *ngIf="taxError" class="error-text"><mat-icon>error_outline</mat-icon> <span>{{taxError}}</span></span>
</span>
<div id="edit-taxonomies">
    <div class="tax-search">
        <div class="input-wrap">
            <input data-lpignore="true" type="search" name="taxonomyPageSearch" autocomplete="taxonomyPageSearch" id="taxonomyPageSearch{{taxonomyPageSearch}}" [(ngModel)]="searchText" placeholder="Search">
        </div>
    </div>
    
    <div class="cf list">
        <div 
            class="taxonomy"
            *ngFor="let tax of taxonomies | taxFilter: searchText; let i = index; trackBy: utils.trackByIndex">
            <h2>                    
                <input 
                    data-lpignore="true"
                    name="taxonomyPageTaxName"
                    autocomplete="taxonomyPageTaxName"
                    id="taxonomyPageTaxName{{taxonomyPageTaxName}}"
                    class="tax-name" 
                    [(ngModel)]="tax.name" 
                    [disabled]="!canEdit" 
                    autosizeInput 
                    (keydown.enter)="updateTaxName(tax)"
                    (blur)="updateTaxName(tax)" 
                    (input)="resetErrors()"
                    placeholder="press enter to save"> 
                <button type="button" (click)="maybeRemoveTax(tax)" *ngIf="canEdit" class="delete"><mat-icon>delete</mat-icon></button>
                <img src="/wp-content/themes/swarm/app/assets/images/loading.gif" *ngIf="tax.loading" class="loader"> 
                <span *ngIf="tax.saved && !tax.loading && !tax.deleting" class="save-text"> <mat-icon>check</mat-icon> Saved! </span>
                <span *ngIf="tax.error && !tax.loading && !tax.deleting" class="error-text"> <mat-icon>error_outline</mat-icon> <span>{{tax.error}}</span></span>
            </h2>
            <div class="chips">
                <div 
                    *ngFor="let option of tax.options; let optionIndex = index; trackBy: utils.trackByIndex" 
                    class="chip">
                    <input 
                        data-lpignore="true"
                        class="option-name" 
                        name="taxonomyPageOptionName"
                        autocomplete="taxonomyPageOptionName"
                        id="taxonomyPageOptionName{{taxonomyPageOptionName}}"
                        [(ngModel)]="option.name" 
                        [disabled]="!canEdit" 
                        autosizeInput 
                        (keydown.enter)="updateOptionName(tax, option)"
                        (input)="resetErrors()"
                        (blur)="updateOptionName(tax, option)"
                        placeholder="press enter to save">
                    <button type="button" (click)="maybeRemoveOption(tax, option)" *ngIf="canEdit"><mat-icon>close</mat-icon></button>
                </div>
                <span *ngIf="canEdit" #newOption>
                    <button type="button" (click)="openOptionInput(newOption)" *ngIf="!newOption.open; else optionInput"><mat-icon>add</mat-icon></button>
                    <ng-template #optionInput>
                        <span>
                            <input 
                                data-lpignore="true"
                                class="new-option" 
                                name="taxonomyPageNewOptionName"
                                autocomplete="taxonomyPageNewOptionName"
                                id="taxonomyPageNewOptionName{{taxonomyPageNewOptionName}}"
                                [disabled]="!canEdit"
                                [(ngModel)]="tax.newOptionName"
                                autosizeInput 
                                (keydown.enter)="addOption(tax)"
                                (input)="resetErrors()"
                                (blur)="resetOptionInput(tax, newOption)"
                                placeholder="press enter to save">
                        </span>
                    </ng-template>
                </span>
            </div>
        </div>

        <div class="taxonomy new" *ngIf="!searchText && canEdit">
            <h2>
                <input 
                    data-lpignore="true"
                    class="new-tax" 
                    name="taxonomyPageNewTaxName"
                    autocomplete="taxonomyPageNewTaxName"
                    id="taxonomyPageNewTaxName{{taxonomyPageNewTaxName}}"
                    [ngClass]="{active: newTaxName}"
                    [disabled]="!canEdit" 
                    autosizeInput 
                    [(ngModel)]="newTaxName"
                    (keydown.enter)="addTax()" 
                    (input)="resetErrors()"
                    placeholder="New Taxonomy"> <mat-icon>add</mat-icon>
                <img src="/wp-content/themes/swarm/app/assets/images/loading.gif" *ngIf="newTaxSaving" class="loader">
                <span *ngIf="newTaxError" class="error-text"><mat-icon>error_outline</mat-icon> <span>{{newTaxError}}</span></span>
            </h2>
        </div> 
        
    </div>
</div>